export enum ModalBsSizeE {
  large = 'large',
  medium = 'medium',
  small = 'small',
  xsmall = 'xsmall',
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xs = 'xs',
}

export type ModalBsSize = keyof typeof ModalBsSizeE;